import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Barcode, Search, History, LogOut, User, Plug, Settings as SettingsIcon, Rocket, CreditCard, BookOpen, Webhook, LifeBuoy, Sparkles, BadgeCheck, Shield, Package } from "lucide-react";

const NAV = [
  { to: "/publish", label: "Publicar", icon: Rocket, testid: "nav-publish" },
  { to: "/batches", label: "Meus Lotes", icon: Package, testid: "nav-batches" },
  { to: "/dashboard", label: "Nova Busca", icon: Search, testid: "nav-new-search" },
  { to: "/pricing", label: "Planos", icon: CreditCard, testid: "nav-pricing", highlight: true },
  { to: "/erp-sync", label: "ERP Sync", icon: Plug, testid: "nav-erp-sync" },
  { to: "/history", label: "Histórico Buscas", icon: History, testid: "nav-history" },
  { to: "/webhooks", label: "Webhooks LGPD", icon: Webhook, testid: "nav-webhooks" },
  { to: "/bling-homologacao", label: "Homologação Bling", icon: BadgeCheck, testid: "nav-bling-homolog" },
  { to: "/settings", label: "Configurações", icon: SettingsIcon, testid: "nav-settings" },
  { to: "/manual", label: "Manual", icon: BookOpen, testid: "nav-manual" },
  { to: "/support", label: "Suporte", icon: LifeBuoy, testid: "nav-support" },
];

const ADMIN_NAV_ITEM = { to: "/admin/users", label: "Admin Users", icon: Shield, testid: "nav-admin-users", highlight: false };

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <aside className="w-full lg:w-64 lg:min-h-screen bg-white border-r border-zinc-200 flex lg:flex-col flex-row justify-between">
      <div className="flex-1">
        <div className="p-6 border-b border-zinc-200">
          <div className="flex items-center gap-2 font-display font-bold text-lg text-[#09090B]">
            <div className="w-8 h-8 rounded-md brand-primary flex items-center justify-center">
              <Barcode className="w-4 h-4 text-white" />
            </div>
            <span>MAGIC SIP</span>
          </div>
        </div>

        <nav className="p-3 flex lg:flex-col flex-row gap-1">
          {[...NAV, ...(user?.is_superadmin ? [ADMIN_NAV_ITEM] : [])].map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end
              data-testid={n.testid}
              className={({ isActive }) => {
                if (n.highlight) {
                  return `relative flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-semibold transition-all shadow-sm ${
                    isActive
                      ? "bg-gradient-to-r from-amber-500 to-orange-500 text-white ring-2 ring-amber-300"
                      : "bg-gradient-to-r from-amber-400 to-orange-500 text-white hover:from-amber-500 hover:to-orange-600 hover:shadow-md hover:scale-[1.02]"
                  }`;
                }
                return `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
                  isActive
                    ? "bg-[#002FA7] text-white font-medium"
                    : "text-zinc-700 hover:bg-zinc-100"
                }`;
              }}
            >
              <n.icon className="w-4 h-4" />
              <span>{n.label}</span>
              {n.highlight && (
                <Sparkles className="w-3.5 h-3.5 ml-auto text-white/90" />
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="p-3 border-t border-zinc-200">
        <div className="flex items-center gap-3 px-2 py-2 mb-1 text-sm">
          <div className="w-8 h-8 rounded-full bg-zinc-200 flex items-center justify-center">
            <User className="w-4 h-4 text-zinc-600" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-medium text-zinc-900 truncate" data-testid="user-name">
              {user?.name || "Usuário"}
            </div>
            <div className="text-xs text-zinc-500 truncate">{user?.email}</div>
          </div>
        </div>
        <button
          onClick={onLogout}
          data-testid="logout-button"
          className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm text-zinc-700 hover:bg-zinc-100 transition-colors"
        >
          <LogOut className="w-4 h-4" />
          <span>Sair</span>
        </button>
      </div>
    </aside>
  );
}
